export default function ContactForm() {
  const handleFormClick = () => {
    window.open('https://ws.formzu.net/dist/S274768490/', '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="py-24 bg-white observe-animation opacity-0">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-12">
            お問い合わせフォーム
          </h2>

          <div className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-3xl p-12 mb-12">
            <i className="ri-file-list-3-line text-6xl text-cyan-600 mb-6"></i>
            <p className="text-xl text-gray-700 mb-8 leading-relaxed">
              お問い合わせは外部フォームにて受け付けております。<br />
              下記のボタンをクリックして、フォームページへお進みください。
            </p>
            <button
              onClick={handleFormClick}
              className="px-12 py-5 bg-cyan-500 text-white rounded-full font-bold text-xl hover:bg-cyan-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
            >
              お問い合わせフォームへ
              <i className="ri-external-link-line text-2xl"></i>
            </button>
          </div>

          <div className="mt-16">
            <p className="text-gray-600 mb-6">お急ぎの方はお電話でもお問い合わせいただけます</p>
            <a href="tel:046-845-4175" className="inline-flex items-center gap-3 text-3xl font-bold text-cyan-600 hover:text-cyan-700 transition-colors cursor-pointer">
              <i className="ri-phone-line"></i>
              046-845-4175
            </a>
            <p className="text-gray-600 mt-2">受付時間:平日 9:00〜18:00</p>
          </div>
        </div>
      </div>
    </section>
  );
}
